const translations = {
    createdOn: 'Created on {{date}}',
    invoiceDetails: 'Invoice Details'
};

export default translations;
